// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */
/* eslint-disable camelcase */
// webgen:keep
/* eslint-disable no-useless-constructor */
// webgen:keep
/* eslint-disable @typescript-eslint/no-unused-vars */
// webgen:keep
/* eslint-disable no-empty-function */
// webgen:keep
import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class SendMessageOutput {
  constructor(data: { [key: string]: any } = {}) {}

  static zero(): SendMessageOutput {
    const zeroValues: ExcludeMethodsDeep<SendMessageOutput> = {};
    return new SendMessageOutput(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type SendMessageOutputWireFormat = {};

type NewSendMessageOutputProps = PartialDeep<SendMessageOutput, { recurseIntoArrays: true }>;
export const NewSendMessageOutput: (props: NewSendMessageOutputProps) => SendMessageOutput = (
  props,
) => new SendMessageOutput(props);

type NewSendMessageOutputFromWireFormatProps = PartialDeep<
  SendMessageOutputWireFormat,
  { recurseIntoArrays: true }
>;
export const NewSendMessageOutputFromWireFormat: (
  props: NewSendMessageOutputFromWireFormatProps,
) => SendMessageOutput = (props) => new SendMessageOutput(props);
